export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <span
      className="grid flex-shrink-0 place-items-center rounded-[0.5rem] bg-zinc-900 text-white shadow-raise"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg style={{ width: size * 0.54, height: size * 0.54 }} viewBox="0 0 20 20" fill="currentColor">
        <path d="M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm0 12 3.5-4.5 2.5 3 3.5-4.5L16 15H4Z" />
      </svg>
    </span>
  );
}
